// ANCHOR React
import React, { memo, useEffect } from 'react';

// ANCHOR Next
import dynamic from 'next/dynamic';

// ANCHOR Base
import { toaster, ToasterContainer } from 'baseui/toast';

// ANCHOR Styles
import { TOAST, TOASTER } from './styles';

const LyonBannerToastContent = dynamic(
  async () => {
    const mod = await import('./LyonBannerToastContent');
    return mod.LyonBannerToastContent;
  }, {
    ssr: false,
  },
);

interface IProps {
  content: string;
  show: boolean;
  isEmailVerification?: boolean;
  isRestoreCourse?: boolean;
  isSuccess?: boolean;
}

export const LyonBannerToast = memo(({
  content, show = true, isEmailVerification, isSuccess, isRestoreCourse,
}: IProps) => {
  useEffect(() => {
    if (show) {
      const toastContent = (
        <LyonBannerToastContent
          content={content}
          isEmailVerification={isEmailVerification}
          isRestoreCourse={isRestoreCourse}
          isSuccess={isSuccess}
        />
      );
      const toasterKey = toaster.info(toastContent, {
        overrides: TOASTER,
      });

      return () => {
        toaster.clear(toasterKey);
      };
    }
    return undefined;
  }, [show, content, isEmailVerification, isSuccess, isRestoreCourse]);

  return (
    <ToasterContainer overrides={TOAST} />
  );
});
